/** @jsxImportSource theme-ui */
import { Container, Box, Flex, Card, Heading, Text } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import Balances from '@/containers/voss/Balances';
import FilterBalances from '@/containers/voss/FilterBalances';

const VossBalancePage = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Card mb="2" variant="widget" sx={{ position: 'relative', zIndex: 100 }}>
                <Heading as="h2">Filter balances with the following criteria</Heading>
                <FilterBalances />
            </Card>

            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Box
                    sx={{
                        borderRadius: 'sm',
                        overflowY: 'scroll',
                        zIndex: 2,
                        justifySelf: 'left',
                        width: '100%',
                        backgroundColor: 'background',
                        padding: 2,
                        position: 'relative',
                    }}
                >
                    <Balances />
                </Box>
            </Flex>
        </Container>
    );
};

export default VossBalancePage;
